<template>
  <span class="k-left-time" :class="skin">
    <span v-if="days > 0" class="num days">{{days}}</span>
    <span v-if="days > 0" class="sp">天</span>
    <span class="num hours">{{pad(hours)}}</span>
    <span class="sp">:</span>
    <span class="num minutes">{{pad(minutes)}}</span>
    <span class="sp">:</span>
    <span class="num seconds">{{pad(seconds)}}</span>
  </span>
</template>

<script>
import { sec2obj } from '../../utils/base'
export default {
  name: 'k-left-time',
  props: ['value', 'skin'],
  computed: {
    secs() {
      const { value } = this
      return value > 0 ? Math.ceil(+value / 1000) : 0
    },
    days() {
      return this.valOf('days')
    },
    hours() {
      return this.valOf('hours')
    },
    minutes() {
      return this.valOf('minutes')
    },
    seconds() {
      return this.valOf('seconds')
    }
  },
  methods: {
    pad(n) {
      return n < 10 ? `0${n}` : n
    },
    valOf(key) {
      return sec2obj(this.secs)[key] || 0
    }
  }
}
</script>
